const initialState = {
    userInfo: {}
};

// eslint-disable-next-line default-param-last
export default function accountReducer(state = initialState, action) {
    switch (action.type) {
        case 'UPDATE_USER_INFO':
            state = {
                ...state,
                ...action.userInfo
            };
            return { ...state };
        default:
            return state;
    }
}
